export const allPersonalizedPrice = [
    'percent',
    'franche',
    'prixfixe',
];
export const personalizedPricePrefixe = [
    'percent',
    'franche',
    'prixfixe',
];
export const personalizedPriceDescription = {
    percent:'percentDesc',
    franche:'francheDesc',
    prixfixe:'prixfixeDesc',
};
export const personalizedPricePercent = [
    'percent',
];
